'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidHistory = require('./mock/bidHistory');

var _bidHistory2 = require('./remote/bidHistory');

var BidHistory = {
    fetchBidHistory: function fetchBidHistory(params) {
        return __MOCK__ ? _bidHistory.BidHistoryMock.fetchBidHistory(params) : _bidHistory2.BidHistoryRemote.fetchBidHistory(params);
    }
};

exports.default = BidHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bidHistory.js
// module id = 5qJt
// module chunks = 46